import { render, staticRenderFns } from "./PayWay.vue?vue&type=template&id=d8bd5f9e&scoped=true&"
import script from "./PayWay.vue?vue&type=script&lang=js&"
export * from "./PayWay.vue?vue&type=script&lang=js&"
import style0 from "./PayWay.vue?vue&type=style&index=0&id=d8bd5f9e&scoped=true&lang=less&"
import style1 from "./PayWay.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bd5f9e",
  null
  
)

export default component.exports